import { COURSE_JOIN, COURSE_LEAVE, coursesUpdated } from '../reducers'
import { all, put, takeEvery } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import * as firebase from 'firebase'

function* joinCourse(action) {
  try {
    yield firebaseUpdateCourse(action.courseId, true)
    yield put(coursesUpdated())
    yield put(push('/cursuri-inscrise'))
  } catch (e) {
    // yield put({ type: FETCHING_DATA_FAILURE })
    //console.log('Error on joinCourse ', e)
  }
}

function* leaveCourse(action) {
  try {
    yield firebaseUpdateCourse(action.courseId, null)
    yield put(push('/cursuri-disponibile'))
  } catch (e) {
    // yield put({ type: FETCHING_DATA_FAILURE })
    //console.log('Error on leaveCourse ', e)
  }
}

const firebaseUpdateCourse = (courseId, value) => {
  //console.log('firebase update course', courseId, value)
  if (courseId) {
    const user = firebase.auth().currentUser
    const uid = user.uid

    const updates = {
      [`courses/${courseId}/students/${uid}`]: value,
    }

    if (value) {
      updates[`students/${uid}/courses/${courseId}/enrolled`] = true
    } else {
      updates[`students/${uid}/courses/${courseId}`] = null
    }

    return firebase
      .database()
      .ref()
      .update(updates)
  }

  throw new Error('Cannot read courseId')
}

function* coursesSaga() {
  try {
    yield all([
      takeEvery(COURSE_JOIN, joinCourse),
      takeEvery(COURSE_LEAVE, leaveCourse),
    ])
  } catch (e) {
    //console.log('error in coursesSaga', e)
  }
}

export default coursesSaga



// WEBPACK FOOTER //
// ./src/sagas/coursesSaga.js